import Joyride from 'react-joyride'
import { useEffect, useState } from 'react'
import { readLocalStorage, writeLocalStorage } from '../../utils/Utils'

const OnboardingTour = ({ steps, storageKey }) => {
  const [run, setRun] = useState(false)

  // launch onBoarding if was not finished before
  useEffect(() => {
    if (storageKey) {
      const stored = readLocalStorage(storageKey)
      if (!stored) {
        setRun(true)
      }
    }
  }, [run])

  useEffect(() => {
    if (run) {
      document.body.style.overflowX = 'hidden'
      document.documentElement.style.overflowX = 'hidden'
    } else {
      document.body.style.overflowX = ''
      document.documentElement.style.overflowX = ''
    }

    return () => {
      document.body.style.overflowX = ''
      document.documentElement.style.overflowX = ''
    }
  }, [run])

  return (
    <>
      <button
        onClick={() => setRun(true)}
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          zIndex: 9999,
          borderRadius: '50%',
          width: '50px',
          height: '50px',
          backgroundColor: '#1976d2',
          color: 'white',
          fontSize: '24px',
          border: 'none',
          cursor: 'pointer',
          boxShadow: '0px 4px 10px rgba(0,0,0,0.2)'
        }}
        title='Iniciar tour'
      >
        ?
      </button>

      <Joyride
        steps={steps}
        run={run}
        continuous
        showSkipButton
        showProgress
        scrollToFirstStep
        spotlightClicks
        disableOverlayClose
        disableCloseOnEsc
        locale={{
          back: 'Atrás',
          close: 'Cerrar',
          last: 'Finalizar',
          next: 'Siguiente',
          skip: 'Saltar'
        }}
        styles={{ options: { zIndex: 10000 } }}
        callback={(data) => {
          const finished = ['finished', 'skipped'].includes(data.status || '')
          if (finished) {
            setRun(false)
            if (storageKey) {
              writeLocalStorage(storageKey, true)
            }
          }
        }}
      />
    </>
  )
}

export default OnboardingTour
